module.exports = __webpack_public_path__ + "static/becoming-wise-27c854c71358272a8beace0d720d4a61.jpg";